import { render } from "./carcheckproject.vue?vue&type=template&id=6660e462&scoped=true&ts=true"
import script from "./carcheckproject.vue?vue&type=script&lang=ts"
export * from "./carcheckproject.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6660e462"]])

export default __exports__